var exports = {
  "k": "xcc377c0b--8caefc--container",
};

module.exports = exports;
